import React, { createContext, useState, useMemo } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import {
  lightTheme,
  darkTheme,
  tokyonight,
  catppuccinmocha,
  heisenberg,
  colibri,
  everforest
} from '../theme';

// Define all the themes here
const themes = {
  light: lightTheme,
  dark: darkTheme,
  tokyonight: tokyonight,
  catppuccinmocha: catppuccinmocha,
  heisenberg: heisenberg,
  colibri: colibri,
  everforest: everforest,
};

const ColorModeContext = createContext({
  mode: 'dark',
  toggleColorMode: () => {},
});

const ColorModeProvider = ({ children }) => {
  // Set initial mode from localStorage or default to 'dark'
  const [mode, setMode] = useState(localStorage.getItem('theme') || 'dark');

  // Handle theme change
  const toggleColorMode = (newMode) => {
    // If newMode is passed (from Select dropdown), set it directly
    if (newMode) {
      setMode(newMode);
      localStorage.setItem('theme', newMode);
    } else {
      // Otherwise, toggle through themes
      setMode((prevMode) => {
        const themeKeys = Object.keys(themes);
        const currentIndex = themeKeys.indexOf(prevMode);
        const nextTheme = themeKeys[(currentIndex + 1) % themeKeys.length];

        // Save the next theme in localStorage
        localStorage.setItem('theme', nextTheme);

        return nextTheme;
      });
    }
  };

  const theme = useMemo(() => {
    return createTheme(themes[mode] || themes.dark); // Default to 'dark' if mode is invalid
  }, [mode]);

  const contextValue = {
    mode,
    toggleColorMode,
  };

  return (
    <ColorModeContext.Provider value={contextValue}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export { ColorModeContext, ColorModeProvider };
